import React, { Fragment } from 'react';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { FilmstripTypeRankingFeatured } from 'site-modules/shared/components/native-ad/filmstrip-type-ranking/filmstrip-type-ranking-featured';
import { NativeVideoAd } from 'site-modules/shared/components/native-ad/video/video-native-ad';
import { SponsoredCars } from 'site-modules/shared/components/core-page/sponsored-cars/sponsored-cars';
import { MinHeightWrapper } from 'site-modules/shared/components/min-height-wrapper/min-height-wrapper';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

export const getSubtypeAds = (trkParam, isMobile, isInline, paddingBottomSegmentListing = '1rem') => {
  const inlineStyle = isInline
    ? {
        marginBottom: '4.5rem',
        marginTop: '4.5rem',
      }
    : {
        paddingBottom: '1rem',
      };
  return {
    pos1: (
      <Fragment key={'pos-1-leaderboard-mrect'}>
        {isMobile ? (
          <MrectNative
            position={'1'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        ) : (
          <div style={{ minHeight: '90px', ...inlineStyle }}>
            <NativeAd
              adNameWired="leaderc"
              nativeStyle="leaderboard"
              wiredOnly
              position={'0'}
              customTargeting={trkParam}
              dfpCollapse
              noRefresh
            />
          </div>
        )}
      </Fragment>
    ),
    pos2: (
      <Fragment key={'pos-2-leaderboard-mrect'}>
        {!isMobile && (
          <div style={{ minHeight: '90px', ...inlineStyle }}>
            <NativeAd
              adNameWired="leaderc"
              nativeStyle="leaderboard"
              wiredOnly
              position={'2'}
              customTargeting={trkParam}
              dfpCollapse
              noRefresh
            />
          </div>
        )}
        {isMobile && (
          <MrectNative
            position={'2'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
    segmentListing: (
      <FilmstripTypeRankingFeatured
        key={'segment-listing-ad'}
        mobile={isMobile}
        inlineStyle={{ ...inlineStyle, paddingBottom: paddingBottomSegmentListing }}
        cardClass="ranking-vehicle-card is-large-card"
      />
    ),
    videoAd: (
      <Experiment name="ads-11436" showDefault key={'video-ad'}>
        <Recipe name="ctrl" isDefault>
          <div className="mx-auto" style={{ width: '360px', height: '363px', ...inlineStyle }}>
            <NativeVideoAd useMinHeight renderWhenViewable verticalOffset="100%" />
          </div>
        </Recipe>
        <Recipe name="chal" />
      </Experiment>
    ),
    filmstrip: (
      <MinHeightWrapper componentType="SPONSORED_CARS" key="filmstrip-ad">
        <SponsoredCars showLargeArrows verticalOffset="50%" showBottomDividingLine={false} inlineStyle={inlineStyle} />
      </MinHeightWrapper>
    ),
    pos3: (
      <Fragment key={'pos-3-leaderboard-mrect'}>
        {!isMobile && (
          <div style={{ minHeight: '90px', ...inlineStyle }}>
            <NativeAd
              adNameWired="leaderc"
              nativeStyle="leaderboard"
              wiredOnly
              position={'3'}
              customTargeting={trkParam}
              dfpCollapse
              noRefresh
            />
          </div>
        )}
        {isMobile && (
          <MrectNative
            position={'3'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
    pos4: (
      <Fragment key={'pos-4-leaderboard-mrect'}>
        {!isMobile && (
          <div style={{ minHeight: '90px', ...inlineStyle }}>
            <NativeAd
              adNameWired="leaderc"
              nativeStyle="leaderboard"
              wiredOnly
              position={'4'}
              customTargeting={trkParam}
              dfpCollapse
              noRefresh
            />
          </div>
        )}
        {isMobile && (
          <MrectNative
            position={'4'}
            refreshable={false}
            mobileOnly
            customTargeting={trkParam}
            useMinHeight
            renderWhenViewable={isMobile}
            verticalOffset="100%"
            style={inlineStyle}
          />
        )}
      </Fragment>
    ),
  };
};
